import React from 'react'

const Footer = () => {
  return (
    <div className='footer_wrap'>
        <ul>
            <li><a href="#">사이트 도움말</a></li>
            <li><a href="#">사이트 이용약관</a></li>
            <li><a href="#">사이트 운영원칙</a></li>
            <li><a href="#">개인정보취급방침</a></li>
            <li><a href="#">책임의 한계와 법적고지</a></li>
            <li><a href="#">게시중단요청서비스</a></li>
            <li><a href="#">고객센터</a></li>
        </ul>
        <address>
            Copyright ©
            <a href="http://rlawhs123@naver.com">Kimkijun</a>
            All Rights Reserved.
        </address>
    </div>
  )
}

export default Footer